import { fetchSlimProfiles } from "@/api/hooks/profile";
import { useAppSession } from "@/auth/AppSessionContext";
import { Dashboards } from "@/dashboard";
import { setTitle } from "@/effects";
import { ProfileAreaLayout } from "@/pages/profile-area-layout";
import { useAppDispatch } from "@/reducer";
import { t } from "@lingui/core/macro";
import { useEffect } from "react";

type ProfilePageProps = {
  showCustomLogo?: boolean;
};

export default function ProfilePage({ showCustomLogo }: ProfilePageProps) {
  const dispatch = useAppDispatch();
  const { sessionActivated } = useAppSession();

  useEffect(() => {
    setTitle(t({ id: "profiles.title", message: "Profiles" }));
  }, []);

  useEffect(() => {
    if (!sessionActivated) {
      return;
    }

    dispatch(fetchSlimProfiles());
  }, [sessionActivated, dispatch]);

  return (
    <ProfileAreaLayout activeTab="profiles" showCustomLogo={showCustomLogo}>
      {sessionActivated && <Dashboards maximized={true} allowCollapse={false} isSideNav={false} />}
    </ProfileAreaLayout>
  );
}
